
import Link from '@/components/ui/link.vue';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'ResultItem',

  components: {
    Link,
    WpImage,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  async fetch() {
    const { data } = await this.getData();
    this.data = { ...data };
  },

  data() {
    return {
      data: null,
    };
  },

  computed: {
    image() {
      if (!this.data) return null;
      switch (this.item.subtype) {
        case 'recipe':
        case 'clinic':
          return this.data.fields.image;
        case 'testimonial':
          return this.data.fields.avatar;
        case 'product':
          return this.data.images.length ? this.data.images[0] : null;
        case 'post':
          return this.data.acf.image;
        case 'page':
          return this.data?._embedded['wp:featuredmedia'] &&
            this.data?._embedded['wp:featuredmedia'][0]
            ? this.data?._embedded['wp:featuredmedia'][0]
            : null;
        default:
          return null;
      }
    },

    title() {
      if (!this.data) return null;
      return this.item.subtype === 'product'
        ? this.data.name
        : this.data.title.rendered;
    },
  },

  methods: {
    getData() {
      if (this.item.subtype === 'product') {
        return this.$wc.products({ id: this.item.id });
      } else {
        return this.$wp[`${this.item.subtype}s`]({
          id: this.item.id,
        });
      }
    },
  },
};
